import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse } from 'BackendApi'
import { apiAuthClient } from '@app/services/apiAuthClient'

type PostStoreCreditCardParams = {
  creditCardToken: string
}

const postStoreCreditCard = async ({
  creditCardToken,
}: PostStoreCreditCardParams) => {
  const apiResponse = await apiAuthClient.post(endpoints.storeCreditCard, {
    creditCardToken,
  })

  return apiResponse.data
}

export const useStoreCreditCard = () =>
  useMutation<unknown, ApiErrorResponse, PostStoreCreditCardParams>(
    postStoreCreditCard
  )
